export const ONBOARDING_STEPS = [
  { key: 'complete-profile',  label: 'Complete your profile',        route: '/account' },
  { key: 'create-project',    label: 'Create your first project',    route: '/new-project' },
  { key: 'upload-template',   label: 'Upload an Excel template',     route: '/project-home' },
  { key: 'add-bridge-column', label: 'Add your first Bridge Column', route: '/project-home' },
  { key: 'run-export',        label: 'Run your first export',        route: '/export' },
];
